export default "__VITE_ASSET__BBK_iufM__";